import { format } from "date-fns";
import { CalculoPagoJudicial } from "../../../../functions/Validaciones/PagoJudicial";
import { FormatterNumber } from "../../../../utils/formatter";
import "../../../shared/styles/UnifiedTable.css";

const Tabla_judiciales = ({ data, onClick, onChange }) => {
  return (
    <div className="unified-table-container">
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div>Nº</div></th>
            <th className="text-start"><div>Persona</div></th>
            <th className="text-start"><div>Detalle</div></th>
            <th className="text-center"><div>Vencimiento</div></th>
            <th className="text-center"><div>Fecha actual</div></th>
            <th className="text-center"><div>Tasa de interés</div></th>
            <th className="text-center"><div>Días de mora</div></th>
            <th className="text-center"><div>Monto</div></th>
            <th className="text-center"><div>Interés</div></th>
            <th className="text-center"><div>Deuda</div></th>
            <th className="text-center"><div>Acciones</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((j, index) => (
            <tr key={index}>
              <td className="text-center">{j.id}</td>
              <td className="text-start">
                <span className="unified-table-link" style={{ cursor: 'default' }}>
                  {j.persona_nombre+" "+j.persona_apellido}
                </span>
              </td>
              <td className="text-start">{j.item}</td>
              <td className="text-center">
                {format(
                  new Date(j.fecha_otorgamiento + " 00:00:00"),
                  "dd/MM/yyyy"
                ).toString()}
              </td>
              <td className="text-center">
                {format(new Date(), "dd/MM/yyyy").toString()}
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  {new Intl.NumberFormat('es-AR').format(j.interes_moratorio)}%
                </span>
              </td>
              <td className="text-center">
                <span className={CalculoPagoJudicial(j).diferencia > 0 ? "unified-badge unified-badge-warning" : "unified-badge unified-badge-secondary"}>
                  {CalculoPagoJudicial(j).diferencia} días
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(j.monto)}
                </span>
              </td>
              <td className="text-end">
                <span className={CalculoPagoJudicial(j).interes > 0 ? "unified-money-negative" : "unified-money"}>
                  {FormatterNumber(CalculoPagoJudicial(j).interes)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {CalculoPagoJudicial(j).deuda < 1
                    ? "$0"
                    : FormatterNumber(CalculoPagoJudicial(j).deuda)}
                </span>
              </td>
              <td className="text-center">
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <label className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <i className="bi bi-file-text me-1"></i>Resumen
                    <button
                      className="d-none"
                      name="resumen-judicial"
                      data-bs-toggle="modal"
                      data-bs-target="#resumen-gastos"
                      onClick={(event) => onClick(event, j)}
                    ></button>
                  </label>
                  <label className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    <i className="bi bi-trash me-1"></i>Eliminar
                    <button
                      className="d-none"
                      name="eliminar-judicial"
                      onClick={(event) => onClick(event, j)}
                    ></button>
                  </label>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot></tfoot>
      </table>
    </div>
  );
};

export default Tabla_judiciales;
